import {
  ScrollView,
  TouchableOpacity,
  TextInput,
  Modal,
  Image,
  Text,
  View,
} from "react-native";
import React, { useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { CommonButton } from "../../../../common/CommonButton";
import { AppScreens } from "../../../Utility/AppScreens";
import { FlatList } from "react-native-gesture-handler";
import GetTokenPopup from "../../../../Components/live-streaming-common-components/GetTokenPopup";
import { useLiveStream } from "../../../../context/LiveStreamContext";

export default function GiftModal({
  openGiftModal,
  closeGiftModal,
  giftData,
  styles,
  handleGiftSelect,
  getTokenPopup,
  setGetTokenPopup,
  userData,
}) {
  const { audienceData } = useLiveStream();
  const [selectedGiftId, setSelectedGiftId] = useState(null);
  const [tokenPackages, setTokenPackages] = useState([
    // Bundle #1: EVENT-ONLY - Quick audience cheer (micro gift)
    // { tokens: 28, price: "£0.29", exchangeRate: "£0.01" },
    // Bundle #2: EVENT-ONLY - Multiple small gifts
    { tokens: 88, price: "£0.90", exchangeRate: "£0.01" },
    // Bundle #3: Starter - 1 Bronze belt + 27 spare (500 base + 77 bonus)
    { tokens: 577, price: "£6.49", exchangeRate: "£0.01" },
    // Bundle #4: Competitor - 2 Bronze belts + 27 spare (1,050 base + 77 bonus)
    { tokens: 1127, price: "£12.49", exchangeRate: "£0.01" },
    // Bundle #5: Champion - Midpoint bundle, best balance (2,150 base + 77 bonus)
    { tokens: 2227, price: "£24.99", exchangeRate: "£0.01" },
    // Bundle #6: Elite - Ideal for regular challengers (4,350 base + 77 bonus)
    { tokens: 4427, price: "£49.99", exchangeRate: "£0.01" },
    // Bundle #7: Legend - High-value player bundle (8,750 base + 77 bonus)
    { tokens: 8827, price: "£99.99", exchangeRate: "£0.01" },
    // Bundle #8: Pro - Ultimate value bundle (20,250 base + 77 bonus)
    { tokens: 20327, price: "£224.99", exchangeRate: "£0.01" },
  ]);

  const [selectedPackage, setSelectedPackage] = useState(null);
  const handlePackageSelect = (selectedPackage) => {
    setSelectedPackage(selectedPackage);
  };

  const eventStatus = audienceData?.eventDetails?.status || "Upcoming";
  const isEventComplete = eventStatus === "complete";

  return (
    <Modal transparent={openGiftModal} visible={true}>
      <View
        style={{
          flex: 1,
          backgroundColor: AppColors.blackTrans_000000a8,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            backgroundColor: AppColors.gray_171717,
            width: "95%",
            bottom: getTokenPopup ? -225 : "-20%",
          }}
        >
          {/* <TouchableOpacity
            onPress={closeGiftModal}
            style={{
              backgroundColor: AppColors.grayColor_505050,
              borderRadius: 8,
              height: 28,
              width: 28,
              alignSelf: "flex-end",
              marginVertical: 10,
              marginRight: 10,
              borderWidth: 1,
              borderColor: AppColors.white,
            }}
          >
            <Image
              source={AppImages.icCancel}
              style={{
                height: 12,
                width: 12,
                marginVertical: 7,
                alignSelf: "center",
              }}
              resizeMode="contain"
            />
          </TouchableOpacity> */}

          <View
            style={{
              flexDirection: "row",
              gap: 10,
              flex: 1,
              justifyContent: "space-between",
              padding: 10,
              backgroundColor: AppColors.gray_2F2F2F,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
              }}
            >
              <Image
                source={AppImages.icWhiteDollarIcon}
                style={{
                  height: 19,
                  width: 19,
                }}
                resizeMode="contain"
              />
              <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                {userData?.tokens ?? 0}
              </Text>
            </View>

            <View
              style={{
                justifyContent: "center",
              }}
            >
              <Text style={AppFontStyle.BOLD_ANYBODY_12}>Token Balance</Text>
            </View>

            <View>
              <Image
                source={AppImages.icQuestion}
                style={{
                  height: 23,
                  width: 24,
                }}
                resizeMode="contain"
              />
            </View>
            <TouchableOpacity
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 5,
                paddingHorizontal: 10,
                backgroundColor: AppColors.appBlackColor_1e1e1e,
              }}
              onPress={() => {
                setGetTokenPopup(!getTokenPopup);
              }}
            >
              <Image
                source={AppImages.icWonDollarIcon}
                style={{
                  height: 12,
                  width: 12,
                }}
                resizeMode="contain"
              />
              <Text style={AppFontStyle.BOLD_ANYBODY_8}>Recharge</Text>
              {!getTokenPopup ? (
                <Image
                  source={AppImages.arrowRight}
                  style={{
                    height: 20,
                    width: 15,
                  }}
                  resizeMode="contain"
                />
              ) : (
                <Image
                  source={AppImages.arrowDown}
                  style={{
                    height: 20,
                    width: 10,
                  }}
                  resizeMode="contain"
                />
              )}
            </TouchableOpacity>
          </View>

          <View
            style={{
              backgroundColor: AppColors.gray_171717,
              paddingHorizontal: getTokenPopup ? 0 : 10,
              paddingVertical: 10,
              opacity: isEventComplete ? 0.5 : 1,
            }}
            pointerEvents={isEventComplete ? "none" : "auto"}
          >
            {getTokenPopup ? (
              <GetTokenPopup
                tokenPackages={tokenPackages}
                selectedPackage={selectedPackage}
                handlePackageSelect={handlePackageSelect}
                boxRightMargin={0}
                width={"100%"}
              />
            ) : (
              <ScrollView
                contentContainerStyle={styles.gridContainer}
                style={{ height: 387 }}
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
              >
                {giftData.map((item) => (
                  <TouchableOpacity
                    key={item.id}
                    onPress={() => setSelectedGiftId(item.id)}
                    style={[
                      styles.itemContainer,
                      {
                        backgroundColor: AppColors.grayColor_282828,
                      },
                    ]}
                  >
                    <View style={styles.giftContent}>
                      <View style={styles.imageContainer}>
                        <Image
                          source={item.gift}
                          style={styles.giftImage}
                          resizeMode="contain"
                        />
                        <Text style={styles.giftName}>{item.giftName}</Text>
                      </View>
                    </View>
                    {item.id === selectedGiftId ? (
                      <CommonButton
                        title="Send"
                        onTap={() => {
                          handleGiftSelect(item);
                        }}
                        buttonStyle={[
                          {
                            backgroundColor: AppColors.red_D43639,
                            borderRadius: 0,
                            padding: 10,
                            marginHorizontal: 7,
                            height: 23,
                            boxShadow: 0,
                          },
                        ]}
                        textStyle={[AppFontStyle.REGULAR_ANYBODY_8, {}]}
                      />
                    ) : (
                      <View style={styles.priceContainer}>
                        <Image
                          source={item.image}
                          style={styles.priceIcon}
                          resizeMode="contain"
                        />
                        <Text style={AppFontStyle.BOLD_ANYBODY_18}>
                          {item.price}
                        </Text>
                      </View>
                    )}
                  </TouchableOpacity>
                ))}
              </ScrollView>
            )}
          </View>
        </View>
      </View>
    </Modal>
  );
}
